import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SaleDocumentPlainObjectQuery, SaleDocumentPlainObjectQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SaleDocumentPlainObjectQuery)
@Wrapper(SaleDocumentPlainObjectQueryHandlerBase)
export class SaleDocumentPlainObjectQueryHandler {
    public constructor(
        http: Http
    ) { }
}
